import { useTranslation } from "react-i18next";
import { paths } from "../lib/paths";
import { AppLink } from "../lib/route-primitives";
import { cn } from "../lib/utils";

/**
 * "Kişisel verileriniz KVKK Aydınlatma Metni kapsamında işlenir." — veri
 * toplanan her formun altında (aydınlatma, verinin toplandığı anda yapılır).
 * Bağlantı yeni sekmede açılır: yarım kalan form kaybolmasın.
 */
export function PrivacyNote({ className, linkClassName }: { className?: string; linkClassName?: string }) {
  const { t } = useTranslation();
  return (
    <p className={className}>
      {t("common.privacyPre")}
      <AppLink
        to={paths.privacy}
        target="_blank"
        rel="noopener"
        className={cn("underline underline-offset-2 transition-colors", linkClassName)}
      >
        {t("common.privacyLink")}
      </AppLink>
      {t("common.privacyPost")}
    </p>
  );
}
